export const COMPANY = {
  name: "Eunice 25",
  tagline: "Colour Your Homes Classically",
  founders: "Owolabi Hamed & Eunice Obazee",
  phone1: "+44 7474 891884",
  phone1Href: "tel:+447474891884",
  phone2: "+44 7401 054414",
  phone2Href: "tel:+447401054414",
  email: "owoeunice@yahoo.com",
  address: "4 Derby Street, Werneth, Oldham OL9 7BW",
};

export const SERVICES = [
  {
    id: "01",
    title: "Interior Wall Painting",
    short: "Walls",
    desc: "Flawless, even coats on every interior wall — from bold feature walls to full-room transformations in any finish you love.",
    img: "https://images.unsplash.com/photo-1615971677499-5467cbab01c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "02",
    title: "Ceiling Painting",
    short: "Ceilings",
    desc: "Crisp, bright ceilings with clean edges and zero drips — the finishing touch that lifts every room.",
    img: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "03",
    title: "Door & Window Frame Painting",
    short: "Frames",
    desc: "Sharp, durable finishes on doors, window frames and trims — the details that make a home feel truly finished.",
    img: "https://images.unsplash.com/photo-1516962080544-eac695c93791?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "04",
    title: "Skirting Board Finishing",
    short: "Skirting",
    desc: "Precision-cut lines and smooth satin or gloss skirting boards that frame every room beautifully.",
    img: "https://images.unsplash.com/photo-1634638415860-cef1aafb60c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: "05",
    title: "Staining & Varnishing",
    short: "Staining",
    desc: "Rich wood stains and protective varnishes for floors, doors and furniture — grain brought back to life.",
    img: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const GALLERY = [
  {
    id: "g1",
    src: "/assets/work2.jpg",
    title: "Grey Emulsion Bedroom",
    category: "Interior Walls",
    spec: "Full room · Matt grey · White skirting",
    real: true,
  },
  {
    id: "g2",
    src: "/assets/work1.jpg",
    title: "Feature Wall Finish",
    category: "Interior Walls",
    spec: "Two-tone grey · Clean cut lines",
    real: true,
  },
  {
    id: "g2b",
    src: "/assets/work5.jpg",
    title: "Dusky Mauve Bedroom Wall",
    category: "Interior Walls",
    spec: "Soft mauve emulsion · Bright white ceiling",
    real: true,
  },
  {
    id: "g2c",
    src: "/assets/work4.jpg",
    title: "Sage Green Feature Walls",
    category: "Interior Walls",
    spec: "Twin sage walls · Crisp ceiling line",
    real: true,
  },
  {
    id: "g2d",
    src: "/assets/work3.jpg",
    title: "Fresh White Panel Door",
    category: "Frames & Skirting",
    spec: "Gloss white door & frame · Cream walls",
    real: true,
  },
  {
    id: "g2e",
    src: "/assets/work6.jpg",
    title: "Warm Taupe Bathroom Wall",
    category: "Interior Walls",
    spec: "Rich taupe emulsion · Spotlight ceiling",
    real: true,
  },
  {
    id: "g2f",
    src: "/assets/work7.jpg",
    title: "Sloped-Ceiling Bathroom in Mauve",
    category: "Interior Walls",
    spec: "Soft mauve · Gloss white skirting",
    real: true,
  },
  {
    id: "g2g",
    src: "/assets/work8.jpg",
    title: "Sage Walls & Textured Ceiling",
    category: "Interior Walls",
    spec: "Deep sage green · Swirl-texture ceiling",
    real: true,
  },
  {
    id: "g2h",
    src: "/assets/work9.jpg",
    title: "Oak Door & Crisp White Frame",
    category: "Frames & Skirting",
    spec: "Satin white architrave · Natural oak door",
    real: true,
  },
  {
    id: "g2i",
    src: "/assets/work10.jpg",
    title: "Soft Grey Radiator Wall",
    category: "Interior Walls",
    spec: "Matt grey emulsion · Sharp corners",
    real: true,
  },
  {
    id: "g3",
    src: "https://images.unsplash.com/photo-1615971677499-5467cbab01c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Classic Cream Lounge",
    category: "Interior Walls",
    spec: "Warm neutral · Silk finish",
  },
  {
    id: "g4",
    src: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Bright Ceiling Refresh",
    category: "Ceilings",
    spec: "Brilliant white · Anti-mould",
  },
  {
    id: "g5",
    src: "https://images.unsplash.com/photo-1516962080544-eac695c93791?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Trim & Frame Detail",
    category: "Frames & Skirting",
    spec: "Satin white · Razor edges",
  },
  {
    id: "g6",
    src: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    title: "Wood Stain Revival",
    category: "Staining",
    spec: "Oak stain · Satin varnish",
  },
];

export const CATEGORIES = ["All", "Interior Walls", "Ceilings", "Frames & Skirting", "Staining"];
